export const PLAYBOOK_HEADER_HEIGHT = 120;
export const PLAYBOOK_FOOTER_HEIGHT = 84;
export const PLAYBOOK_CONTENT_MAX_WIDTH = 1440;
export const WEB_PLAYBOOK_QUERY = '(min-width: 1100px)';
